import { getUserSession } from '@utils/local-storage';
import { useEffect } from 'react';

export const useHaveUser = (setUser: (user: string) => void) => {
  useEffect(() => {
    const user = getUserSession();
    if (user) {
      setUser(user.email);
    }
  });
};
